import React from 'react';

import { NewStyledIconButton, StyledTooltip } from 'styles/common';

import { SENTIMENTS, SENTIMENTS_TYPES, SENTIMENT_TOGGLE_ORDER } from 'constants/ProjectConstants';
import { AppreciativeFeedbackIcon, ConstructiveFeedbackIcon, NeutralFeedbackIcon } from 'constants/icons';
import theme from 'constants/theme';

const PositiveNegativeSentimentToggle = ({
  selected = SENTIMENTS.neutral,
  updateSentiment = () => {},
  neutralIconSize = 'fixed12px',
  sentimentIconSize = 'fixed14px',
}) => {
  /* Short circuiting here. this component won't render anything. ( this was done as part of feedback revamp ) */

  return null;

  const handleToggle = () => {
    const currentSelectedSentimentIndex = SENTIMENT_TOGGLE_ORDER.findIndex((sentiment) => sentiment === selected);

    if (currentSelectedSentimentIndex > -1) {
      updateSentiment(SENTIMENT_TOGGLE_ORDER[(currentSelectedSentimentIndex + 1) % SENTIMENT_TOGGLE_ORDER.length]);
    } else {
      console.error('Selected Sentiment not found.');
    }
  };

  return (
    <NewStyledIconButton padding="large" onClick={handleToggle}>
      {selected === SENTIMENTS.appreciative && (
        <StyledTooltip title={SENTIMENTS_TYPES.appreciative.label}>
          <AppreciativeFeedbackIcon color={theme.palette.grey.dark} size={sentimentIconSize} />
        </StyledTooltip>
      )}
      {selected === SENTIMENTS.constructive && (
        <StyledTooltip title={SENTIMENTS_TYPES.constructive.label}>
          <ConstructiveFeedbackIcon color={theme.palette.grey.dark} size={sentimentIconSize} />
        </StyledTooltip>
      )}
      {selected === SENTIMENTS.neutral && (
        <StyledTooltip title={SENTIMENTS_TYPES.neutral.label}>
          <NeutralFeedbackIcon color={theme.palette.grey.dark} size={neutralIconSize} />
        </StyledTooltip>
      )}
    </NewStyledIconButton>
  );
};

export default PositiveNegativeSentimentToggle;
